import React from 'react'
import { animationVariantsRight } from 'src/theme/animations/swipeIn'
import Detachable from 'src/assets/logos/Detachable.avif'

import {
    ContentImage,
    ContentImageSection,
    ContentSelectMobile,
    MenuItemContent,
} from './styles'
import { Content, ContentTypographyNavigation, MenuButtonDes } from '../styles'
import MenuItem from '@mui/material/MenuItem'
import { useTranslations } from 'src/provider/LocaleProvider'
import { useDropdownInteraction } from 'src/hook'
import { HeaderLabels } from 'src/constants'

export function MobileMenuComponent() {
    const t = useTranslations()
    const { GrowOptions, navigateOptions } = HeaderLabels()
    const {
        handleClick,
        dropdownElement,
        setOpenDropdown,
        openDropdown,
        handleClose,
    } = useDropdownInteraction()

    const handleOptionClick = (option: string) => {
        if (option === 'Option 1') {
            setOpenDropdown((prev) => !prev)
        } else {
            handleClose()
        }
    }
    return (
        <ContentSelectMobile
            marginLeft={['medium', 'xmedium', 0, 'header']}
            animate="animate"
            variants={animationVariantsRight}
        >
            <MenuButtonDes onClick={handleClick}>
                <ContentImageSection>
                    <ContentImage src={Detachable} alt={'logo'} />
                </ContentImageSection>
            </MenuButtonDes>
            <MenuItemContent
                anchorEl={dropdownElement}
                open={Boolean(dropdownElement)}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={() => handleOptionClick('Option 1')}
                    className={'center'}
                    key={'id'}
                >
                    <ContentTypographyNavigation
                        variant={'h2'}
                        fontSize={'xxsmall'}
                        fontWeight={500}
                    >
                        {t('cta.growProject')}
                    </ContentTypographyNavigation>
                </MenuItem>
                {openDropdown && (
                    <>
                        {GrowOptions.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                className={'center'}
                            >
                                <Content
                                    to={`/${option.navigate}`}
                                    key={`navData-${option.label}`}
                                >
                                    <ContentTypographyNavigation
                                        variant={'h2'}
                                        fontSize={'xxsmall'}
                                        fontWeight={500}
                                    >
                                        {option.label}
                                    </ContentTypographyNavigation>
                                </Content>
                            </MenuItem>
                        ))}
                    </>
                )}
                {navigateOptions.map((el) => {
                    return (
                        <MenuItem className={'center'} key={el.label}>
                            <Content
                                to={`/${el.navigation}`}
                                key={`navData-${el.label}`}
                            >
                                <ContentTypographyNavigation
                                    variant={'h2'}
                                    fontSize={'xxsmall'}
                                    fontWeight={500}
                                >
                                    {el.label}
                                </ContentTypographyNavigation>
                            </Content>
                        </MenuItem>
                    )
                })}
            </MenuItemContent>
        </ContentSelectMobile>
    )
}
